import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import { syncCreatorNotifications } from "../../Utils/pushNotifications";

const CreatorPushSubscriptionSync = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const user = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (
      !isAuthenticated ||
      !user.id ||
      typeof Notification === "undefined" ||
      Notification.permission !== "granted"
    ) {
      return;
    }

    void syncCreatorNotifications().catch((error) => {
      console.warn("Unable to sync creator notifications", error);
    });
  }, [isAuthenticated, user.id, user.role]);

  return null;
};

export default CreatorPushSubscriptionSync;
